import { useDebounce } from './useDebounce';

// Detects if a user is currently typing
export function useIsTyping(inputValue: string, delay: number) {
	const textWhenDone = useDebounce(inputValue, delay);
	return inputValue !== textWhenDone;
}
